// Serializes autosaves. A trailing draft adopts only the confirmed version of
// this queue's preceding save; remote versions must never be stamped onto it.
export function createReportSaveQueue({ initial, version, getDraft, persist, onSaved }) {
  let saved = { ...initial }, currentVersion = version, pending = null, blocked = null, stopped = false;
  const equal = (a, b) => a.report === b.report && a.internal_report === b.internal_report;
  return {
    save() {
      if (stopped) return Promise.resolve();
      if (blocked) return Promise.reject(blocked);
      if (pending) return pending;
      pending = (async () => {
        for (;;) {
          if (stopped) return;
          const sent = { ...getDraft() };
          if (equal(sent, saved)) return;
          let result;
          try { result = await persist({ ...sent, edit_version: currentVersion }); }
          catch (error) {
            // Do not retry an unknown write or a stale version automatically.
            // The owner preserves the draft and offers explicit recovery.
            blocked = error;
            throw error;
          }
          saved = sent;
          currentVersion = result.edit_version;
          if (!stopped) await onSaved(result, { ...getDraft() });
        }
      })().finally(() => { pending = null; });
      return pending;
    },
    replaceCleanSnapshot(initial, version) {
      if (pending || blocked || stopped || !equal(getDraft(), saved)) throw new Error("Editor changed while refreshing");
      saved = { ...initial };
      currentVersion = version;
    },
    adoptEditorBaseline(draft) { if (!pending) saved = { ...draft }; },
    stop() { stopped = true; },
  };
}
